export default "__VITE_ASSET__BbfhAlJx__"